/* eslint-disable no-case-declarations */

import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'

import {
  ALL_RISK_LEVEL_VALUE,
  CAMPAIGNS_PAGE_SIZE,
  DEFAULT_CARD_ORDERING,
  DEFAULT_SIMULATION_SORT,
  EXPORT_SIMULATIONS_CSV_ASYNC,
  GET_CAMPAIGNS_LIST_ASYNC,
  GET_EMAIL_PREVIEW_ASYNC,
  GET_LEVEL_COUNTS_ASYNC,
  GET_METRIC_BANNER_ASYNC,
  GET_MONITORING_STATUS_INFO_ASYNC,
  GET_PARTICIPANT_DETAILS_ASYNC,
  GET_PSIMA_COMPANIES_ASYNC,
  GET_SIMULATION_LIST_ASYNC,
  GET_SIMULATIONS_META_ASYNC,
  LOAD_MORE_CAMPAIGNS,
  MOCK_TIME,
  PAGINATE_SIMULATIONS,
  POST_EMAIL_FEEDBACK_ASYNC,
  RESET_SIMULATION_PARTICIPANTS,
  RISK_LEVELS_VALUES,
  SCHEDULE_STATUSES_VALUES,
  SEND_SIMULATIONS_ASYNC,
  SET_CARDS_ORDERING,
  SET_EXCLUDED_PARTICIPANTS,
  SET_PLACEHOLDER_FILTER,
  SET_RISK_LEVEL_SELECTED_FILTERS,
  SET_SELECTED_CAMPAIGNS,
  SET_SIMULATION_DATE_RANGE,
  SET_SIMULATION_DEPARTMENTS,
  SET_SIMULATION_SORT,
  SET_SINGLE_CAMPAIGN_ID,
  SET_STATUS_SELECTED_FILTERS,
} from './constants'
import {
  capSuggestedParticipants,
  isSameDateRange,
  isSameSort,
  isSimulationPageGone,
  SIMULATIONS_FALLBACK_PAGE,
} from './utils'

const SIMULATION_LIST_QUERY_FIELD_BY_ACTION = {
  [SET_STATUS_SELECTED_FILTERS]: 'statusSelectedFilters',
  [SET_SIMULATION_DEPARTMENTS]: 'selectedDepartments',
  [SET_SIMULATION_DATE_RANGE]: 'dateRange',
  [SET_SIMULATION_SORT]: 'sort',
}

/* Re-sending the current value (re-applying the same range) must not reset the pager
   or reload the list. The list epic reads the resulting loader flag to skip the fetch. */
const IS_SAME_SIMULATION_QUERY_VALUE_BY_ACTION = {
  [SET_SIMULATION_DATE_RANGE]: isSameDateRange,
  [SET_SIMULATION_SORT]: isSameSort,
}

const initialState = {
  scheduleInfo: {
    data: {
      lastUpdate: MOCK_TIME,
      nextSchedule: MOCK_TIME,
      status: SCHEDULE_STATUSES_VALUES.ACTIVE,
    },
    loader: false,
  },
  campaignsData: {
    items: [],
    selectedCampaigns: [],
    excludedParticipants: {},
    loader: false,
    loadMoreLoader: false,
    page: 1,
    hasMore: true,
    totalCount: 0,
    riskLevelSelectedFilters: [],
    placeholderFilter: null,
    ordering: DEFAULT_CARD_ORDERING,
  },
  simulationData: {
    items: [],
    loader: false,
    listFetched: false,
    listError: false,
    participantErrors: {},
    page: 1,
    pendingPage: null,
    pageJump: false,
    totalPages: 1,
    totalItems: 0,
    participantsLoaders: [],
    participantDetails: {},
    statusSelectedFilters: [],
    selectedDepartments: [],
    dateRange: null,
    sort: DEFAULT_SIMULATION_SORT,
    exportLoader: false,
    navigationError: false,
    failedNavigationPage: null,
    emailPreviewLoader: false,
    emailPreviewError: false,
    emailFeedbackLoader: false,
    emailFeedbackPending: null,
    // 'up' | 'down' per `${simulationId}:${participantId}`, so a rated email stays rated.
    emailFeedbackByParticipant: {},
    emailPreviewData: {},
  },
  launchLoader: false,
  singleCampaignId: null,
  levelCountsData: {
    data: {},
    loader: false,
  },
  metricBannerData: {
    data: {},
    loader: false,
  },
  statusCountsData: {
    data: {},
    loader: false,
  },
  // { status, code } -- code is psima_not_enabled when the feature is off for the
  // selected tenant, null for a plain permission 403.
  accessError: null,
  // Ids of the clients that have PSIMA, for the company selector. This is per-user
  // partner data rather than tenant data, so it survives the tenant reset below.
  psimaCompanyIds: [],
  // Not-yet-fetched and none-exist are different answers: an empty list before the
  // response arrives would tell a partner they have no PSIMA companies at all.
  psimaCompaniesLoaded: false,
  psimaCompaniesError: false,
}

// TODO: remove
const mockSimulationData = [
  {
    id: '019d6c7b-2a42-7a51-970d-e9fb21495d8b',
    title: 'Advisory Board Member Requesting Financial Data Access',
    participantsCount: 1,
    status: 'sending',
    engagement: {
      clicked: 0,
      reported: 0,
      noEngagement: 100,
    },
    launchedBy: 'Eyal Benishti',
    createdAt: '2026-04-08T09:45:04Z',
    validUntil: '2021-05-28T07:00:00Z',
  },
  {
    id: '019d6c7b-2a42-7a51-970d-e9fb21495d8ba',
    title: 'Advisory Board Member Requesting Financial Data Access2',
    participantsCount: 1,
    status: 'sending',
    engagement: {
      clicked: 0,
      reported: 0,
      noEngagement: 100,
    },
    launchedBy: 'Eyal Benishti 2',
    createdAt: '2026-04-08T09:46:04Z',
    validUntil: '2021-06-28T07:00:00Z',
  },
]
const mockedParticipantsDetails = [
  {
    id: '019d6c7b-2a5d-7660-869b-a145a28cf3ff',
    profileId: 316445,
    lastUserActivityAt: null,
    status: 'not_started',
    isEmailReady: true,
    isVip: true,
    name: 'Lior Tenzer',
    email: 'lior@ironscales.com',
    department: 'Finance',
    jobTitle: 'VP, Finance',
  },
]
const emailPreviewData = {
  profileId: 316445,
  sender: 'Tammy Schuring <tschuring@ironscales.internalconnectivity.com>',
  title: 'Re: Advisory board onboarding access',
  body: '<html><body><div dir="ltr"><div>Hi Lior,</div><div><br></div><div>I\'m reaching out following my recent appointment reaching out following my recent appointment reaching  reaching out following my recent appointment reaching out following my recent appointment reaching out following my recent appointment out following my recent appointment to IRONSCALES\' Advisory Board. Glenn mentioned you\'d be the right contact to coordinate access for the quarterly review work.</div><div><br></div><div>I\'ll need dashboard and reporting system credentials to start the fiscal health assessment we discussed. Can you provision access and set up a brief onboarding call <a href="ironscales.internalconnectivity.com/t/_1/welcome/37418788-SwctRGsZlBlNaw">here</a> before end of week?</div><div><br></div><div>Thanks</div><div><br></div><div>Tammy Schuring<br>Advisory Board Member<br>IRONSCALES</div></div></body></html>',
  sentAt: '2026-04-08T09:45:04Z',
  recipient: 'Lior Tenzer <lior@ironscales.com>',
}

const normalizeCampaignItems = (items = []) =>
  items.map((item) => {
    const audienceData = item?.audience?.data || []

    return {
      ...item,
      audience: {
        searchKeys: audienceData.map(({ searchKey }) => searchKey).filter(Boolean),
        suggestedProfiles: capSuggestedParticipants(
          audienceData.flatMap(({ suggestedProfiles = [] }) => suggestedProfiles)
        ),
      },
    }
  })

const PRESELECT_CAP = 5

const getAutoSelectedCampaignIds = (items) => {
  const eligible = items.filter((item) => item.audience.suggestedProfiles.length > 0)

  const actionable = eligible.filter(
    ({ level }) => level === RISK_LEVELS_VALUES.HIGH || level === RISK_LEVELS_VALUES.MEDIUM
  )

  if (actionable.length) {
    return actionable.slice(0, PRESELECT_CAP).map(({ id }) => id)
  }

  const mostRecentLow = eligible
    .filter(({ level }) => level === RISK_LEVELS_VALUES.LOW)
    .sort((first, second) => new Date(second.createdAt) - new Date(first.createdAt))[0]

  return mostRecentLow ? [mostRecentLow.id] : []
}

const getDuplicateExcludedParticipants = (items, selectedIds) => {
  const selected = new Set(selectedIds)
  const bestByParticipant = {}

  items.forEach((item) => {
    if (!selected.has(item.id)) return

    item.audience.suggestedProfiles.forEach((profile) => {
      const fitScore = profile.fitScore ?? 0
      const current = bestByParticipant[profile.id]

      if (!current || fitScore > current.fitScore) {
        bestByParticipant[profile.id] = { campaignId: item.id, fitScore }
      }
    })
  })

  const excluded = {}

  items.forEach((item) => {
    if (!selected.has(item.id)) return

    item.audience.suggestedProfiles.forEach((profile) => {
      if (bestByParticipant[profile.id].campaignId !== item.id) {
        excluded[item.id] = [...(excluded[item.id] || []), profile.id]
      }
    })
  })

  return excluded
}

const reconcileExcludedParticipants = (
  items,
  selectedIds,
  prevExcluded = {},
  prevSelectedIds = []
) => {
  const selected = new Set(selectedIds)
  const prevSelected = new Set(prevSelectedIds)
  const newlySelected = new Set(selectedIds.filter((id) => !prevSelected.has(id)))

  const occurrencesByParticipant = new Map()

  items.forEach((item) => {
    if (!selected.has(item.id)) return

    item.audience.suggestedProfiles.forEach((profile) => {
      const occurrences = occurrencesByParticipant.get(profile.id) || []
      occurrences.push({ campaignId: item.id, fitScore: profile.fitScore ?? 0 })
      occurrencesByParticipant.set(profile.id, occurrences)
    })
  })

  const excluded = {}

  occurrencesByParticipant.forEach((occurrences, participantId) => {
    if (occurrences.length < 2) return

    // A card the user just turned on claims its participants first, so selecting a
    // card never collapses it straight into the empty state on the same click.
    const newlySelectedOccurrences = occurrences.filter(({ campaignId }) =>
      newlySelected.has(campaignId)
    )

    let ownerCampaignId

    if (newlySelectedOccurrences.length) {
      ownerCampaignId = [...newlySelectedOccurrences].sort(
        (first, second) => second.fitScore - first.fitScore
      )[0].campaignId
    } else {
      const prevOwners = occurrences.filter(
        ({ campaignId }) =>
          prevSelected.has(campaignId) && !(prevExcluded[campaignId] || []).includes(participantId)
      )

      ownerCampaignId =
        prevOwners.length === 1
          ? prevOwners[0].campaignId
          : [...occurrences].sort((first, second) => second.fitScore - first.fitScore)[0].campaignId
    }

    occurrences.forEach(({ campaignId }) => {
      if (campaignId !== ownerCampaignId) {
        excluded[campaignId] = [...(excluded[campaignId] || []), participantId]
      }
    })
  })

  return excluded
}

function psimaReducer(state = initialState, action) {
  switch (action.type) {
    case GET_MONITORING_STATUS_INFO_ASYNC.INITIATE:
      return {
        ...state,
        scheduleInfo: {
          ...state.scheduleInfo,
          loader: true,
        },
      }
    case GET_MONITORING_STATUS_INFO_ASYNC.SUCCESS:
      return {
        ...state,
        scheduleInfo: {
          ...state.scheduleInfo,
          data: action.payload.data.data,
          // data: {
          //   lastUpdate: '2026-01-30T00:00:00Z',
          //   nextSchedule: '2026-04-09T13:03:00Z',
          //   status: 'active',
          // },
          loader: false,
        },
      }
    case GET_MONITORING_STATUS_INFO_ASYNC.ERROR:
      return {
        ...state,
        scheduleInfo: {
          ...state.scheduleInfo,
          loader: false,
        },
      }
    case SET_SELECTED_CAMPAIGNS:
      return {
        ...state,
        campaignsData: {
          ...state.campaignsData,
          selectedCampaigns: action.payload.selectedCampaigns,
          excludedParticipants: reconcileExcludedParticipants(
            state.campaignsData.items,
            action.payload.selectedCampaigns,
            state.campaignsData.excludedParticipants,
            state.campaignsData.selectedCampaigns
          ),
        },
      }
    case GET_CAMPAIGNS_LIST_ASYNC.INITIATE:
      return {
        ...state,
        campaignsData: {
          ...state.campaignsData,
          loader: true,
        },
      }
    case GET_CAMPAIGNS_LIST_ASYNC.SUCCESS:
      const isLoadMoreCampaigns = action.payload.page > 1
      const campaignMeta = action.payload.data.meta
      const newCampaignItems = normalizeCampaignItems(action.payload.data.data || [])
      const campaignItems = isLoadMoreCampaigns
        ? [...state.campaignsData.items, ...newCampaignItems]
        : newCampaignItems
      const isPreselect = action.payload.isPreselectAllCampaigns && !isLoadMoreCampaigns
      const selectedCampaigns = isPreselect
        ? getAutoSelectedCampaignIds(newCampaignItems)
        : state.campaignsData.selectedCampaigns
      const excludedParticipants = isPreselect
        ? getDuplicateExcludedParticipants(campaignItems, selectedCampaigns)
        : state.campaignsData.excludedParticipants

      return {
        ...state,
        campaignsData: {
          ...state.campaignsData,
          items: campaignItems,
          selectedCampaigns,
          excludedParticipants,
          loader: false,
          loadMoreLoader: false,
          hasMore: campaignMeta
            ? action.payload.page < campaignMeta.totalPages && newCampaignItems.length > 0
            : newCampaignItems.length >= CAMPAIGNS_PAGE_SIZE,
          totalCount: campaignMeta?.count ?? campaignItems.length,
          riskLevelSelectedFilters: action.payload.isPreselectAllCampaigns
            ? [ALL_RISK_LEVEL_VALUE]
            : state.campaignsData.riskLevelSelectedFilters,
        },
      }
    case GET_CAMPAIGNS_LIST_ASYNC.ERROR:
      return {
        ...state,
        campaignsData: {
          ...state.campaignsData,
          loader: false,
          loadMoreLoader: false,
        },
      }
    case SET_EXCLUDED_PARTICIPANTS:
      return {
        ...state,
        campaignsData: {
          ...state.campaignsData,
          excludedParticipants: action.payload.excludedParticipants,
        },
      }
    case SEND_SIMULATIONS_ASYNC.INITIATE:
      return {
        ...state,
        launchLoader: true,
      }
    case SEND_SIMULATIONS_ASYNC.SUCCESS:
      return {
        ...state,
        campaignsData: {
          ...state.campaignsData,
          loader: true,
        },
        launchLoader: false,
      }
    case SEND_SIMULATIONS_ASYNC.ERROR:
      return {
        ...state,
        launchLoader: false,
      }
    case SET_RISK_LEVEL_SELECTED_FILTERS:
      return {
        ...state,
        campaignsData: {
          ...state.campaignsData,
          riskLevelSelectedFilters: action.payload.value,
          page: 1,
          hasMore: true,
          loader: true,
        },
      }
    case SET_PLACEHOLDER_FILTER:
      return {
        ...state,
        campaignsData: {
          ...state.campaignsData,
          placeholderFilter: action.payload.value,
          page: 1,
          hasMore: true,
          loader: true,
        },
      }
    case SET_CARDS_ORDERING:
      return {
        ...state,
        campaignsData: {
          ...state.campaignsData,
          ordering: action.payload.value,
          page: 1,
          hasMore: true,
          loader: true,
        },
      }
    case GET_SIMULATION_LIST_ASYNC.INITIATE:
      return {
        ...state,
        simulationData: {
          ...state.simulationData,
          loader: true,
          listError: false,
          navigationError: false,
          failedNavigationPage: null,
        },
      }
    case GET_SIMULATION_LIST_ASYNC.SUCCESS:
      const listMeta = action.payload.data.meta || {}
      const newItems = action.payload.data.data || []
      const resolvedPage =
        action.payload.page ?? state.simulationData.pendingPage ?? state.simulationData.page
      const totalPages = listMeta.totalPages || 1
      const totalItems = listMeta.totalItems || 0
      return {
        ...state,
        simulationData: {
          ...state.simulationData,
          items: newItems,
          page: resolvedPage,
          pendingPage: null,
          pageJump: false,
          totalPages,
          totalItems,
          loader: false,
          listFetched: true,
          listError: false,
          navigationError: false,
          failedNavigationPage: null,
        },
      }
    case GET_SIMULATION_LIST_ASYNC.ERROR: {
      const { simulationData } = state
      const isPageGone = isSimulationPageGone(action.error)
      const listSettled = { loader: false, listFetched: true, pageJump: false, pendingPage: null }

      if (simulationData.pageJump && !isPageGone) {
        return {
          ...state,
          simulationData: {
            ...simulationData,
            ...listSettled,
            listError: false,
            navigationError: true,
            failedNavigationPage: simulationData.pendingPage,
          },
        }
      }

      return {
        ...state,
        simulationData: {
          ...simulationData,
          ...listSettled,
          items: [],
          listError: true,
          navigationError: false,
          failedNavigationPage: null,
          page: isPageGone
            ? SIMULATIONS_FALLBACK_PAGE
            : (simulationData.pendingPage ?? simulationData.page),
        },
      }
    }
    case SET_SINGLE_CAMPAIGN_ID:
      return {
        ...state,
        singleCampaignId: action.payload.value,
      }
    case GET_LEVEL_COUNTS_ASYNC.INITIATE:
      return {
        ...state,
        levelCountsData: {
          ...state.levelCountsData,
          loader: true,
        },
        campaignsData: {
          ...state.campaignsData,
          page: 1,
          hasMore: true,
          loader: true,
        },
      }
    case GET_LEVEL_COUNTS_ASYNC.SUCCESS:
      return {
        ...state,
        levelCountsData: {
          ...state.levelCountsData,
          data: action.payload.data.data,
          loader: false,
        },
      }
    case GET_LEVEL_COUNTS_ASYNC.ERROR:
      return {
        ...state,
        levelCountsData: {
          ...state.levelCountsData,
          loader: false,
        },
      }
    case GET_METRIC_BANNER_ASYNC.INITIATE:
      return {
        ...state,
        metricBannerData: {
          ...state.metricBannerData,
          loader: true,
        },
      }
    case GET_METRIC_BANNER_ASYNC.SUCCESS:
      return {
        ...state,
        metricBannerData: {
          ...state.metricBannerData,
          data: action.payload.data,
          loader: false,
        },
      }
    case GET_METRIC_BANNER_ASYNC.ERROR:
      return {
        ...state,
        metricBannerData: {
          ...state.metricBannerData,
          loader: false,
        },
      }
    case GET_PARTICIPANT_DETAILS_ASYNC.INITIATE:
      return {
        ...state,
        simulationData: {
          ...state.simulationData,
          participantsLoaders: [...state.simulationData.participantsLoaders, action.payload.id],
          participantErrors: Object.fromEntries(
            Object.entries(state.simulationData.participantErrors || {}).filter(
              ([id]) => id !== action.payload.id
            )
          ),
        },
      }
    case GET_PARTICIPANT_DETAILS_ASYNC.ERROR: {
      const failedId = action.payload?.id
      return {
        ...state,
        simulationData: {
          ...state.simulationData,
          participantsLoaders: state.simulationData.participantsLoaders.filter(
            (id) => id !== failedId
          ),
          participantErrors: failedId
            ? { ...(state.simulationData.participantErrors || {}), [failedId]: true }
            : state.simulationData.participantErrors || {},
        },
      }
    }
    case GET_PARTICIPANT_DETAILS_ASYNC.SUCCESS:
      return {
        ...state,
        simulationData: {
          ...state.simulationData,
          participantsLoaders: state.simulationData.participantsLoaders.filter(
            (id) => id !== action.payload.id
          ),
          participantDetails: {
            ...state.simulationData.participantDetails,
            [action.payload.id]: action.payload.data.data,
          },
        },
      }
    case RESET_SIMULATION_PARTICIPANTS:
      return {
        ...state,
        simulationData: {
          ...state.simulationData,
          participantsLoaders: [],
          participantDetails: {},
        },
      }
    case GET_EMAIL_PREVIEW_ASYNC.INITIATE:
      return {
        ...state,
        simulationData: {
          ...state.simulationData,
          emailPreviewLoader: true,
          emailPreviewError: false,
          // Drop the previous employee's email so it never shows under the next name.
          emailPreviewData: {},
        },
      }
    case GET_EMAIL_PREVIEW_ASYNC.SUCCESS:
      return {
        ...state,
        simulationData: {
          ...state.simulationData,
          emailPreviewLoader: false,
          emailPreviewError: false,
          emailPreviewData: action.payload.data.data,
        },
      }
    case GET_EMAIL_PREVIEW_ASYNC.ERROR:
      return {
        ...state,
        simulationData: {
          ...state.simulationData,
          emailPreviewLoader: false,
          emailPreviewError: true,
          emailPreviewData: {},
        },
      }
    case POST_EMAIL_FEEDBACK_ASYNC.INITIATE:
      return {
        ...state,
        simulationData: {
          ...state.simulationData,
          emailFeedbackLoader: true,
          emailFeedbackPending: {
            key: `${action.payload.id}:${action.payload.participantId}`,
            feedback: action.payload.feedback ? 'up' : 'down',
          },
        },
      }
    case POST_EMAIL_FEEDBACK_ASYNC.SUCCESS: {
      const pending = state.simulationData.emailFeedbackPending
      return {
        ...state,
        simulationData: {
          ...state.simulationData,
          emailFeedbackLoader: false,
          emailFeedbackPending: null,
          emailFeedbackByParticipant: pending
            ? {
                ...state.simulationData.emailFeedbackByParticipant,
                [pending.key]: pending.feedback,
              }
            : state.simulationData.emailFeedbackByParticipant,
        },
      }
    }
    case POST_EMAIL_FEEDBACK_ASYNC.ERROR:
      return {
        ...state,
        simulationData: {
          ...state.simulationData,
          emailFeedbackLoader: false,
          emailFeedbackPending: null,
        },
      }
    case PAGINATE_SIMULATIONS: {
      const targetPage = action.payload.page
      if (targetPage === state.simulationData.page) {
        return state
      }
      return {
        ...state,
        simulationData: {
          ...state.simulationData,
          pendingPage: targetPage,
          pageJump: true,
          loader: true,
          listError: false,
          navigationError: false,
        },
      }
    }
    case LOAD_MORE_CAMPAIGNS:
      return {
        ...state,
        campaignsData: {
          ...state.campaignsData,
          page: state.campaignsData.page + 1,
          loadMoreLoader: true,
        },
      }
    case SET_STATUS_SELECTED_FILTERS:
    case SET_SIMULATION_DEPARTMENTS:
    case SET_SIMULATION_DATE_RANGE:
    case SET_SIMULATION_SORT: {
      const field = SIMULATION_LIST_QUERY_FIELD_BY_ACTION[action.type]
      const isSameValue = IS_SAME_SIMULATION_QUERY_VALUE_BY_ACTION[action.type]
      if (isSameValue?.(state.simulationData[field], action.payload.value)) return state

      return {
        ...state,
        simulationData: {
          ...state.simulationData,
          [field]: action.payload.value,
          page: 1,
          pendingPage: null,
          pageJump: false,
          loader: true,
          listError: false,
          navigationError: false,
          failedNavigationPage: null,
        },
      }
    }
    case EXPORT_SIMULATIONS_CSV_ASYNC.INITIATE:
      return {
        ...state,
        simulationData: {
          ...state.simulationData,
          exportLoader: true,
        },
      }
    case EXPORT_SIMULATIONS_CSV_ASYNC.SUCCESS:
    case EXPORT_SIMULATIONS_CSV_ASYNC.ERROR:
    case EXPORT_SIMULATIONS_CSV_ASYNC.CANCEL:
      return {
        ...state,
        simulationData: {
          ...state.simulationData,
          exportLoader: false,
        },
      }
    case GET_SIMULATIONS_META_ASYNC.INITIATE:
      return {
        ...state,
        statusCountsData: {
          ...state.statusCountsData,
          loader: true,
        },
      }
    case GET_SIMULATIONS_META_ASYNC.SUCCESS:
      return {
        ...state,
        statusCountsData: {
          ...state.statusCountsData,
          data: action.payload.data.data,
        },
      }
    case GET_SIMULATIONS_META_ASYNC.ERROR:
      return {
        ...state,
        statusCountsData: {
          ...state.statusCountsData,
          loader: false,
        },
      }
    case GET_PSIMA_COMPANIES_ASYNC.SUCCESS:
      return {
        ...state,
        psimaCompanyIds: (action.payload.data.companies || []).map((company) => company.id),
        psimaCompaniesLoaded: true,
        psimaCompaniesError: false,
      }
    case GET_PSIMA_COMPANIES_ASYNC.ERROR:
      // Cleared rather than left pending, or the page spins forever.
      return { ...state, psimaCompaniesLoaded: true, psimaCompaniesError: true }
    case COMPANY_FILTER_CHANGE:
      // Loaders go true here because the refetch fires on ...DATA_ASYNC.SUCCESS, which
      // has no INITIATE case -- otherwise the UI shows an empty state for the whole trip.
      return {
        ...initialState,
        psimaCompanyIds: state.psimaCompanyIds,
        psimaCompaniesLoaded: state.psimaCompaniesLoaded,
        psimaCompaniesError: state.psimaCompaniesError,
        scheduleInfo: { ...initialState.scheduleInfo, loader: true },
        campaignsData: { ...initialState.campaignsData, loader: true },
        simulationData: { ...initialState.simulationData, loader: true },
        levelCountsData: { ...initialState.levelCountsData, loader: true },
        metricBannerData: { ...initialState.metricBannerData, loader: true },
      }
    default:
      return state
  }
}

// Page-level reads only: mounted statically, so it sees every 403 in the app,
// and one failed row save must not replace the page with a denial screen.
const TENANT_ACCESS_READS = [
  GET_MONITORING_STATUS_INFO_ASYNC,
  GET_LEVEL_COUNTS_ASYNC,
  GET_METRIC_BANNER_ASYNC,
  GET_CAMPAIGNS_LIST_ASYNC,
  GET_SIMULATION_LIST_ASYNC,
  GET_SIMULATIONS_META_ASYNC,
]
const TENANT_ACCESS_ERRORS = new Set(TENANT_ACCESS_READS.map(({ ERROR }) => ERROR))
const TENANT_ACCESS_RECOVERIES = new Set(TENANT_ACCESS_READS.map(({ SUCCESS }) => SUCCESS))

// Wraps rather than adding cases: those ERROR types already have cases that own loader
// clearing, and a second `case` for the same type would never run.
export default function spearPhishingAgentReducer(state, action) {
  const next = psimaReducer(state, action)

  if (TENANT_ACCESS_ERRORS.has(action.type) && action.error?.status === 403) {
    return {
      ...next,
      accessError: { status: 403, code: action.error.response?.code ?? null },
    }
  }

  // Without this a transient 403 wedges the shell for a single-tenant user, who has no
  // COMPANY_FILTER_CHANGE to reset it.
  if (next.accessError && TENANT_ACCESS_RECOVERIES.has(action.type)) {
    return { ...next, accessError: null }
  }

  return next
}
